export const normalizePhoneNumber = (phoneNumber: string) =>
  phoneNumber.replace(/\+/g, '').replace(/ /g, '');